require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-knee-pain-squats.json") })
        }
      }, "path---blog-knee-pain-squats");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-knee-pain-squats!./.cache/json/blog-knee-pain-squats.json
// module id = 295
// module chunks = 231608221292675